/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { loadGoogleMaps, GTA_BOUNDS, GMAPS_KEY, db, doc, getDoc, collection, query, where, getDocs, limit } from "./firebase";

// ── COLORS ────────────────────────────────────────────────────────────
export const TEAL="#0D9488",GOLD="#F4A261",GREEN="#059669",RED="#E63946",WARN="#FB923C";
export const BG="#F8FAFC",WHITE="#FFFFFF",TEXT="#1E293B",SUB="#64748B",LIGHT="#E2E8F0",DC="#F1F5F9";

// ── PRESET LISTS ──────────────────────────────────────────────────────
export const OCCUPATION_PRESETS=[
  "地產經紀","金融顧問","會計師","律師","醫生","護士","IT/科技","工程師",
  "設計師","教師","廚師","攝影師","保險經紀","銷售","市場營銷","自營業主",
  "學生","退休","自由職業","其他"
];
export const EXPERTISE_PRESETS=[
  "投資理財","地產買賣","移民留學","稅務規劃","汽車維修","裝修工程",
  "美容護膚","健身瑜珈","烹飪美食","攝影","音樂","藝術","科技IT",
  "育兒教育","法律諮詢","保險規劃","創業","電商","其他"
];
export const HOBBY_PRESETS=[
  "行山遠足","釣魚","高爾夫","健身","瑜珈","跑步","游泳","打波",
  "烹飪","品酒","咖啡","旅遊","攝影","音樂","睇書","電影",
  "打機","露營","園藝","寵物","投資","下棋","其他"
];

// Layout + type scale
export const LAYOUT_MAX_W=480;
export const BASE_FS=17;

// ── GLOBAL CSS ────────────────────────────────────────────────────────
export const css=`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700;900&display=swap');
  html{-webkit-text-size-adjust:100%;text-size-adjust:100%;}
  .root,.root *{box-sizing:border-box;margin:0;padding:0;font-family:'Noto Sans TC',sans-serif;font-size:${BASE_FS}px;line-height:1.55;}
  .root{background:${BG};min-height:100vh;font-size:${BASE_FS}px;}
  input,textarea,select{font-family:'Noto Sans TC',sans-serif;font-size:${BASE_FS}px;line-height:1.45;}
  input::placeholder,textarea::placeholder{color:#94A3B8;font-size:${BASE_FS}px;}
  @keyframes go-spin{to{transform:rotate(360deg)}}
  @keyframes go-fade{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
  @keyframes go-pulse{0%,100%{transform:translate(-50%,-50%) scale(1);opacity:.3}50%{transform:translate(-50%,-50%) scale(2);opacity:0}}
  .go-fade{animation:go-fade .35s ease forwards}
`;

// ── ATOMS ─────────────────────────────────────────────────────────────
export const Btn=({label,onClick,color=TEAL,textColor="#fff",disabled,style={}})=>(
  <button onClick={onClick} disabled={disabled} style={{
    background:disabled?"#CBD5E1":color,color:disabled?"#94A3B8":textColor,
    border:"none",borderRadius:16,padding:"16px 0",minHeight:52,fontSize:20,fontWeight:700,
    width:"100%",cursor:disabled?"not-allowed":"pointer",
    display:"flex",alignItems:"center",justifyContent:"center",gap:8,
    boxShadow:disabled?"none":`0 2px 8px ${color}33`,transition:"opacity .2s",...style
  }}>{label}</button>
);

export const Inp=({placeholder,value,onChange,type="text",maxLength,style:s={}})=>(
  <input type={type} placeholder={placeholder} value={value} onChange={onChange} maxLength={maxLength}
    style={{width:"100%",background:WHITE,border:`1.5px solid ${LIGHT}`,borderRadius:14,
      padding:"14px 16px",minHeight:52,fontSize:18,color:TEXT,outline:"none",marginBottom:12,
      transition:"border-color .2s",...s}}
    onFocus={e=>e.target.style.borderColor=TEAL}
    onBlur={e=>e.target.style.borderColor=LIGHT}/>
);

export const Sel=({value,onChange,disabled,children,style:s={}})=>(
  <select value={value} onChange={onChange} disabled={disabled}
    style={{width:"100%",background:WHITE,border:`1.5px solid ${LIGHT}`,borderRadius:14,
      padding:"14px 16px",minHeight:52,fontSize:18,color:TEXT,outline:"none",marginBottom:12,
      cursor:disabled?"not-allowed":"pointer",transition:"border-color .2s",...s}}
    onFocus={e=>{e.target.style.borderColor=TEAL;}}
    onBlur={e=>{e.target.style.borderColor=LIGHT;}}>
    {children}
  </select>
);

export const Card=({children,style={},onClick})=>(
  <div onClick={onClick} style={{background:WHITE,borderRadius:18,padding:18,marginBottom:14,
    boxShadow:"0 1px 6px rgba(0,0,0,0.06)",border:`1px solid ${LIGHT}`,...style}}>
    {children}
  </div>
);

export const Bar=({title,onBack,right})=>(
  <div style={{background:WHITE,borderBottom:`1px solid ${LIGHT}`,padding:"16px 20px",
    display:"flex",alignItems:"center",gap:14,position:"sticky",top:0,zIndex:50}}>
    <button onClick={onBack} style={{background:DC,border:"none",color:SUB,borderRadius:12,
      width:44,minWidth:44,height:44,cursor:"pointer",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>←</button>
    <span style={{color:TEXT,fontWeight:700,fontSize:20,flex:1,lineHeight:1.35}}>{title}</span>
    {right&&right}
  </div>
);

export const Wrap=({children,style={}})=>(
  <div className="go-fade" style={{maxWidth:LAYOUT_MAX_W,margin:"0 auto",padding:"18px 20px 52px",...style}}>{children}</div>
);

export const Sec=({title,children})=>(
  <div style={{marginBottom:18}}>
    <p style={{color:SUB,fontSize:14,fontWeight:600,marginBottom:10,letterSpacing:.4}}>{title}</p>
    {children}
  </div>
);

export const Toggle=({on,onToggle,label,sub,icon})=>(
  <div onClick={onToggle} style={{display:"flex",alignItems:"center",gap:14,cursor:"pointer",padding:"10px 0"}}>
    {icon&&<span style={{fontSize:24}}>{icon}</span>}
    <div style={{flex:1}}>
      <div style={{color:TEXT,fontSize:17,fontWeight:500,lineHeight:1.4}}>{label}</div>
      {sub&&<div style={{color:SUB,fontSize:15,marginTop:2,lineHeight:1.4}}>{sub}</div>}
    </div>
    <div style={{width:52,height:30,borderRadius:15,background:on?TEAL:LIGHT,transition:"all .2s",position:"relative",flexShrink:0}}>
      <div style={{position:"absolute",width:26,height:26,borderRadius:"50%",background:WHITE,
        top:2,left:on?24:2,transition:"all .2s",boxShadow:"0 1px 4px rgba(0,0,0,0.2)"}}/>
    </div>
  </div>
);

export const Tag=({label,color=TEAL})=>(
  <span style={{background:color+"15",border:`1px solid ${color}33`,color,
    borderRadius:20,padding:"5px 12px",fontSize:14,fontWeight:600,display:"inline-block",margin:"3px"}}>{label}</span>
);

// ── STAR RATING ───────────────────────────────────────────────────────
export const StarRating=({rating=0,onRate,size=30,readonly=false})=>(
  <div style={{display:"flex",gap:2}}>
    {[1,2,3,4,5].map(i=>(
      <span key={i} onClick={()=>!readonly&&onRate&&onRate(i)}
        style={{fontSize:size,cursor:readonly?"default":"pointer",
          color:i<=rating?GOLD:"#D1D5DB",transition:"color .15s"}}>★</span>
    ))}
  </div>
);

export const StarDisplay=({rating=0,count=0,size=17})=>(
  <div style={{display:"flex",alignItems:"center",gap:6}}>
    <span style={{color:GOLD,fontSize:size}}>★</span>
    <span style={{color:TEXT,fontSize:size-1,fontWeight:600}}>{rating>0?rating.toFixed(1):"新"}</span>
    {count>0&&<span style={{color:SUB,fontSize:size-2}}>({count})</span>}
  </div>
);

// ── INTEREST PICKER (dropdown + custom + multi-select) ────────────────
export const InterestPicker=({title,presets=[],selected=[],onChange,max=5})=>{
  const [custom,setCustom]=useState("");
  const toggle=v=>{
    if(selected.includes(v)) onChange(selected.filter(x=>x!==v));
    else if(selected.length<max) onChange([...selected,v]);
  };
  const addCustom=()=>{
    const v=custom.trim();
    if(v&&!selected.includes(v)&&selected.length<max){
      onChange([...selected,v]);
      setCustom("");
    }
  };
  return(
    <div style={{marginBottom:12}}>
      <p style={{color:SUB,fontSize:15,fontWeight:600,marginBottom:8,lineHeight:1.4}}>{title}（最多{max}個）</p>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
        {presets.map(p=>(
          <div key={p} onClick={()=>toggle(p)} style={{
            padding:"9px 14px",borderRadius:22,fontSize:15,cursor:"pointer",
            background:selected.includes(p)?TEAL+"22":WHITE,
            border:`1.5px solid ${selected.includes(p)?TEAL:LIGHT}`,
            color:selected.includes(p)?TEAL:SUB,fontWeight:500}}>
            {p}
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:6}}>
        <input value={custom} onChange={e=>setCustom(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&addCustom()}
          placeholder="自訂..."
          style={{flex:1,border:`1.5px solid ${LIGHT}`,borderRadius:12,padding:"12px 14px",minHeight:48,fontSize:16,outline:"none",color:TEXT}}/>
        <button onClick={addCustom} disabled={!custom.trim()||selected.length>=max}
          style={{background:custom.trim()&&selected.length<max?TEAL:"#CBD5E1",color:WHITE,
            border:"none",borderRadius:12,padding:"12px 16px",minHeight:48,fontSize:17,fontWeight:600,cursor:"pointer"}}>+</button>
      </div>
      {selected.length>0&&(
        <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:8}}>
          {selected.map(s=>(
            <span key={s} onClick={()=>toggle(s)} style={{
              background:TEAL+"15",border:`1px solid ${TEAL}33`,color:TEAL,
              borderRadius:20,padding:"6px 12px",fontSize:14,fontWeight:600,cursor:"pointer"}}>
              {s} ✕
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

// ── PROFILE INTERESTS DISPLAY ─────────────────────────────────────────
export const InterestTags=({occupation,expertise=[],hobbies=[]})=>(
  <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
    {occupation&&<Tag label={`💼 ${occupation}`} color={TEAL}/>}
    {expertise.map(e=><Tag key={e} label={`🎯 ${e}`} color={GOLD}/>)}
    {hobbies.map(h=><Tag key={h} label={`🎮 ${h}`} color={GREEN}/>)}
  </div>
);

// ── ADDRESS AUTOCOMPLETE ──────────────────────────────────────────────
export const AddressInput=({placeholder,value,onChange,onSelect})=>{
  const [suggestions,setSuggestions]=useState([]);
  const [show,setShow]=useState(false);
  const timer=useRef(null);
  const svcRef=useRef(null);

  useEffect(()=>{
    loadGoogleMaps().then(()=>{
      svcRef.current=new window.google.maps.places.AutocompleteService();
    });
  },[]);

  const handleChange=e=>{
    const v=e.target.value;
    onChange(v);
    if(timer.current)clearTimeout(timer.current);
    if(v.length<2){setSuggestions([]);setShow(false);return;}
    timer.current=setTimeout(()=>{
      if(!svcRef.current)return;
      svcRef.current.getPlacePredictions({
        input:v,
        componentRestrictions:{country:"ca"},
        bounds:new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(GTA_BOUNDS.sw.lat,GTA_BOUNDS.sw.lng),
          new window.google.maps.LatLng(GTA_BOUNDS.ne.lat,GTA_BOUNDS.ne.lng)
        ),
        types:["geocode","establishment"],
      },(predictions,status)=>{
        if(status===window.google.maps.places.PlacesServiceStatus.OK&&predictions){
          setSuggestions(predictions.map(p=>p.description));
          setShow(true);
        }else{
          setSuggestions([]);setShow(false);
        }
      });
    },350);
  };

  return(
    <div style={{position:"relative",marginBottom:10}}>
      <input placeholder={placeholder} value={value} onChange={handleChange}
        onBlur={()=>setTimeout(()=>setShow(false),200)}
        style={{width:"100%",background:WHITE,border:`1.5px solid ${LIGHT}`,borderRadius:14,
          padding:"14px 16px",minHeight:52,fontSize:18,color:TEXT,outline:"none",transition:"border-color .2s"}}
        onFocus={e=>{e.target.style.borderColor=TEAL;if(suggestions.length>0)setShow(true);}}/>
      {show&&suggestions.length>0&&(
        <div style={{position:"absolute",top:"100%",left:0,right:0,background:WHITE,
          border:`1px solid ${LIGHT}`,borderRadius:12,boxShadow:"0 4px 20px rgba(0,0,0,0.1)",
          zIndex:100,overflow:"hidden"}}>
          {suggestions.slice(0,5).map((s,i)=>(
            <div key={i} onMouseDown={()=>{onSelect(s);setShow(false);}}
              style={{padding:"14px 16px",fontSize:16,color:TEXT,cursor:"pointer",
                borderBottom:i<4?`1px solid ${LIGHT}`:"none",
                display:"flex",alignItems:"center",gap:10}}
              onMouseEnter={e=>e.currentTarget.style.background=DC}
              onMouseLeave={e=>e.currentTarget.style.background=WHITE}>
              <span style={{color:TEAL,fontSize:18}}>📍</span>{s}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ── MAP PICKER (Full screen) ──────────────────────────────────────────
export const MapPicker=({onConfirm,onClose,title="選擇地點"})=>{
  const mapDivRef=useRef(null);
  const mapRef=useRef(null);
  const markerRef=useRef(null);
  const [addr,setAddr]=useState("");
  const [geocoding,setGeocoding]=useState(false);
  const GTA_CENTER={lat:43.7615,lng:-79.4111};

  useEffect(()=>{
    loadGoogleMaps().then(()=>{
      const map=new window.google.maps.Map(mapDivRef.current,{
        center:GTA_CENTER,zoom:12,disableDefaultUI:true,zoomControl:true,
        styles:[{featureType:"poi",stylers:[{visibility:"off"}]}],
      });
      mapRef.current=map;
      const marker=new window.google.maps.Marker({
        position:GTA_CENTER,map,draggable:true,
        icon:{path:window.google.maps.SymbolPath.CIRCLE,scale:10,fillColor:TEAL,fillOpacity:1,strokeColor:WHITE,strokeWeight:3},
      });
      markerRef.current=marker;
      const geocoder=new window.google.maps.Geocoder();
      const geocodePos=(pos)=>{
        setGeocoding(true);
        geocoder.geocode({location:pos},(results,status)=>{
          setGeocoding(false);
          if(status==="OK"&&results[0])setAddr(results[0].formatted_address);
          else setAddr(`${pos.lat().toFixed(5)}, ${pos.lng().toFixed(5)}`);
        });
      };
      marker.addListener("dragend",()=>geocodePos(marker.getPosition()));
      map.addListener("click",(e)=>{
        marker.setPosition(e.latLng);
        geocodePos(e.latLng);
      });
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(pos=>{
          const p={lat:pos.coords.latitude,lng:pos.coords.longitude};
          map.setCenter(p);map.setZoom(15);marker.setPosition(p);
          geocodePos(new window.google.maps.LatLng(p.lat,p.lng));
        },()=>{},{enableHighAccuracy:true,timeout:5000});
      }
    });
  },[]);

  return(
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:1300,background:BG,display:"flex",flexDirection:"column"}}>
      <Bar title={title} onBack={onClose}/>
      <div ref={mapDivRef} style={{flex:1}}/>
      <div style={{padding:18,background:WHITE,borderTop:`1px solid ${LIGHT}`}}>
        <p style={{color:geocoding?WARN:TEXT,fontSize:16,marginBottom:12,minHeight:48,lineHeight:1.45}}>
          {geocoding?"定位中...":addr||"拖動地圖上嘅標記或點擊選擇位置"}
        </p>
        <Btn label="確認位置" color={addr?TEAL:"#CBD5E1"} disabled={!addr}
          onClick={()=>{if(addr)onConfirm(addr);}}/>
      </div>
    </div>
  );
};

// ── GPS BUTTON ────────────────────────────────────────────────────────
export const GPSBtn=({onLocate,loading})=>(
  <div onClick={loading?undefined:onLocate}
    style={{display:"flex",alignItems:"center",gap:8,background:"#F0FDF4",border:`1px solid #BBF7D0`,
      borderRadius:12,padding:"12px 14px",marginBottom:10,cursor:loading?"wait":"pointer"}}>
    <span style={{fontSize:20}}>{loading?"🔄":"📍"}</span>
    <span style={{color:GREEN,fontSize:16,fontWeight:600}}>
      {loading?"定位中...":"用GPS自動定位"}
    </span>
  </div>
);

// ── MAP VIEW (read-only: 車主→上車點，或上車→目的地全程駕車路線) ─────────
export const MapView=({pickupAddr,destAddr,driverLoc,h=200})=>{
  const mapDivRef=useRef(null);
  const mapRef=useRef(null);
  const pickupMarkerRef=useRef(null);
  const driverMarkerRef=useRef(null);
  const directionsRef=useRef(null);
  const mapInitIdRef=useRef(0);
  const [mapReady,setMapReady]=useState(false);

  const tripMode=destAddr!=null&&String(destAddr).trim().length>0;

  useEffect(()=>{
    if(!pickupAddr)return;
    let cancelled=false;
    const runId=++mapInitIdRef.current;
    const stillCurrent=()=>!cancelled&&mapInitIdRef.current===runId;
    setMapReady(false);
    loadGoogleMaps().then(()=>{
      if(!stillCurrent()||!mapDivRef.current)return;
      const destTrim=destAddr!=null?String(destAddr).trim():"";
      const showFullTrip=destTrim.length>0;

      if(showFullTrip){
        const map=new window.google.maps.Map(mapDivRef.current,{
          center:{lat:43.6532,lng:-79.3832},zoom:10,disableDefaultUI:true,zoomControl:true,
        });
        mapRef.current=map;
        pickupMarkerRef.current=null;
        driverMarkerRef.current=null;
        const dr=new window.google.maps.DirectionsRenderer({
          map,
          suppressMarkers:false,
          polylineOptions:{strokeColor:TEAL,strokeWeight:5},
        });
        directionsRef.current=dr;
        const ds=new window.google.maps.DirectionsService();
        const geocoder=new window.google.maps.Geocoder();
        /** Directions API 未開或配額問題時，用兩點 geocode + 大圓直線，至少見到起終同大致走向 */
        const drawStraightFallback=()=>{
          geocoder.geocode({address:pickupAddr,region:"ca"},(r1,s1)=>{
            if(!stillCurrent())return;
            geocoder.geocode({address:destTrim,region:"ca"},(r2,s2)=>{
              if(!stillCurrent())return;
              try{dr.setMap(null);}catch(_){/* ignore */}
              if(s1==="OK"&&r1?.[0]&&s2==="OK"&&r2?.[0]){
                const p1=r1[0].geometry.location;
                const p2=r2[0].geometry.location;
                new window.google.maps.Marker({position:p1,map,label:"A",title:pickupAddr});
                new window.google.maps.Marker({position:p2,map,label:"B",title:destTrim});
                new window.google.maps.Polyline({
                  path:[p1,p2],
                  geodesic:true,
                  strokeColor:TEAL,
                  strokeOpacity:0.88,
                  strokeWeight:4,
                  map,
                });
                const b=new window.google.maps.LatLngBounds();
                b.extend(p1);
                b.extend(p2);
                map.fitBounds(b,{top:44,bottom:44,left:44,right:44});
              }
              setMapReady(true);
            });
          });
        };
        ds.route({
          origin:pickupAddr,
          destination:destTrim,
          travelMode:window.google.maps.TravelMode.DRIVING,
          provideRouteAlternatives:false,
        },(result,status)=>{
          if(!stillCurrent())return;
          if(status==="OK"&&result?.routes?.[0]){
            try{
              dr.setDirections(result);
              map.fitBounds(result.routes[0].bounds,{top:40,bottom:40,left:40,right:40});
            }catch(e){
              if(process.env.NODE_ENV==="development")console.warn("[MapView] setDirections failed",e);
              drawStraightFallback();
              return;
            }
            setMapReady(true);
            return;
          }
          if(process.env.NODE_ENV==="development"){
            console.warn("[MapView] DirectionsService status:",status,"— 改用直線後備（請喺 Google Cloud 啟用 Directions API 以顯示實際路線）");
          }
          drawStraightFallback();
        });
        return;
      }

      const geocoder=new window.google.maps.Geocoder();
      geocoder.geocode({address:pickupAddr},(results,status)=>{
        if(!stillCurrent())return;
        if(status!=="OK"||!results[0]){
          setMapReady(true);
          return;
        }
        const pos=results[0].geometry.location;
        if(!stillCurrent()||!mapDivRef.current)return;
        const map=new window.google.maps.Map(mapDivRef.current,{
          center:pos,zoom:15,disableDefaultUI:true,zoomControl:true,
        });
        mapRef.current=map;
        pickupMarkerRef.current=new window.google.maps.Marker({
          position:pos,map,
          icon:{path:window.google.maps.SymbolPath.CIRCLE,scale:10,fillColor:TEAL,fillOpacity:1,strokeColor:WHITE,strokeWeight:3},
        });
        directionsRef.current=new window.google.maps.DirectionsRenderer({
          map,suppressMarkers:true,polylineOptions:{strokeColor:TEAL,strokeWeight:4},
        });
        setMapReady(true);
      });
    });
    return()=>{cancelled=true;};
  },[pickupAddr,destAddr]);

  useEffect(()=>{
    if(!mapReady||!driverLoc||!mapRef.current||tripMode)return;
    const dPos=new window.google.maps.LatLng(driverLoc.lat,driverLoc.lng);
    if(driverMarkerRef.current){
      driverMarkerRef.current.setPosition(dPos);
    }else{
      driverMarkerRef.current=new window.google.maps.Marker({
        position:dPos,map:mapRef.current,
        icon:{url:"data:image/svg+xml,"+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><circle cx="16" cy="16" r="14" fill="#0D9488" stroke="white" stroke-width="3"/><text x="16" y="21" text-anchor="middle" font-size="16" fill="white">🚗</text></svg>'),
          scaledSize:new window.google.maps.Size(36,36)},
      });
    }
    if(pickupMarkerRef.current){
      const ds=new window.google.maps.DirectionsService();
      ds.route({origin:dPos,destination:pickupMarkerRef.current.getPosition(),travelMode:"DRIVING"},
      (result,status)=>{
        if(status==="OK"){
          directionsRef.current.setDirections(result);
          const bounds=new window.google.maps.LatLngBounds();
          bounds.extend(dPos);
          bounds.extend(pickupMarkerRef.current.getPosition());
          mapRef.current.fitBounds(bounds,{top:30,bottom:30,left:30,right:30});
        }
      });
    }
  },[driverLoc,mapReady,tripMode]);

  return(
    <div style={{position:"relative",width:"100%",height:h,borderRadius:14,overflow:"hidden",
      border:`1px solid ${LIGHT}`,background:DC}}>
      <div ref={mapDivRef} style={{width:"100%",height:"100%"}}/>
      {!mapReady&&(
        <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",
          justifyContent:"center",background:DC}}>
          <span style={{fontSize:24,animation:"go-spin 1s linear infinite"}}>🔄</span>
          <span style={{color:SUB,fontSize:16,marginLeft:10}}>載入地圖...</span>
        </div>
      )}
      <div style={{position:"absolute",bottom:8,right:10,background:"rgba(255,255,255,0.9)",
        borderRadius:8,padding:"4px 10px",fontSize:13,color:SUB}}>📍 Google Maps</div>
    </div>
  );
};

// ── CHAT BOX ──────────────────────────────────────────────────────────
export const ChatBox=({messages=[],onSend,myId,myName,h=300})=>{
  const [text,setText]=useState("");
  const scrollRef=useRef(null);

  useEffect(()=>{
    if(scrollRef.current){
      scrollRef.current.scrollTop=scrollRef.current.scrollHeight;
    }
  },[messages.length]);

  const send=()=>{
    if(!text.trim())return;
    onSend(text.trim());
    setText("");
  };

  return(
    <div style={{border:`1px solid ${LIGHT}`,borderRadius:14,overflow:"hidden",background:WHITE}}>
      <div style={{background:TEAL,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontSize:20}}>💬</span>
        <span style={{color:WHITE,fontSize:17,fontWeight:700}}>聊天</span>
        <span style={{color:"rgba(255,255,255,0.75)",fontSize:14,marginLeft:"auto"}}>
          {messages.length} 條訊息
        </span>
      </div>
      <div ref={scrollRef} style={{height:h,overflowY:"auto",padding:12,background:"#F8FAFC"}}>
        {messages.length===0&&(
          <div style={{textAlign:"center",padding:24,color:SUB,fontSize:16,lineHeight:1.5}}>
            暫無訊息，發送第一條訊息開始聊天 💬
          </div>
        )}
        {messages.map((m,i)=>{
          const isMe=m.senderId===myId;
          return(
            <div key={i} style={{display:"flex",justifyContent:isMe?"flex-end":"flex-start",marginBottom:8}}>
              <div style={{maxWidth:"75%"}}>
                <div style={{fontSize:13,color:SUB,marginBottom:3,
                  textAlign:isMe?"right":"left"}}>{isMe?"你":m.senderName}</div>
                <div style={{background:isMe?TEAL:WHITE,color:isMe?WHITE:TEXT,
                  borderRadius:isMe?"14px 14px 4px 14px":"14px 14px 14px 4px",
                  padding:"12px 14px",fontSize:17,lineHeight:1.5,
                  border:isMe?"none":`1px solid ${LIGHT}`,
                  boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
                  {m.text}
                </div>
                <div style={{fontSize:12,color:SUB,marginTop:3,textAlign:isMe?"right":"left"}}>
                  {m.time||""}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{display:"flex",gap:10,padding:10,borderTop:`1px solid ${LIGHT}`,background:WHITE}}>
        <input value={text} onChange={e=>setText(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&send()}
          placeholder="輸入訊息..."
          style={{flex:1,border:`1.5px solid ${LIGHT}`,borderRadius:22,padding:"12px 16px",minHeight:48,
            fontSize:17,outline:"none",color:TEXT}}/>
        <button type="button" onClick={send} aria-label="發送"
          style={{background:text.trim()?TEAL:"#CBD5E1",color:WHITE,border:"none",
            borderRadius:"50%",width:48,minWidth:48,height:48,cursor:"pointer",
            display:"flex",alignItems:"center",justifyContent:"center"}}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M12 19V5M5 12l7-7 7 7"/></svg>
        </button>
      </div>
    </div>
  );
};

// ── BOTTOM NAV（items 可用 Icon: Lucide 組件，或舊式 icon 字串）────────────
export const BottomNav=({active,onChange,items,bottomInset=0})=>(
  <div style={{position:"fixed",bottom:bottomInset,left:0,right:0,zIndex:100,
    background:WHITE,borderTop:`1px solid ${LIGHT}`,
    display:"flex",maxWidth:LAYOUT_MAX_W,margin:"0 auto",
    boxShadow:"0 -2px 10px rgba(0,0,0,0.05)",paddingBottom:"env(safe-area-inset-bottom)"}}>
    {items.map(t=>{
      const c=active===t.key?TEAL:SUB;
      const Icon=t.Icon;
      return(
        <div key={t.key} onClick={()=>onChange(t.key)}
          style={{flex:1,textAlign:"center",padding:"10px 6px 8px",cursor:"pointer",
            color:c,transition:"color .2s"}}>
          <div style={{marginBottom:4,display:"flex",justifyContent:"center",alignItems:"center",minHeight:28}}>
            {Icon?<Icon size={26} strokeWidth={2.25} color={c} aria-hidden/>:<span style={{fontSize:24}}>{t.icon}</span>}
          </div>
          <div style={{fontSize:13,fontWeight:active===t.key?700:500,lineHeight:1.25}}>{t.label}</div>
        </div>
      );
    })}
  </div>
);

// ── TAB BAR（tabs 可用 Icon 或 icon 字串）──────────────────────────────
export const TabBar=({tabs,active,onChange})=>(
  <div style={{display:"flex",background:WHITE,borderBottom:`1px solid ${LIGHT}`,overflow:"auto"}}>
    {tabs.map(t=>{
      const c=active===t.key?TEAL:SUB;
      const TabIcon=t.Icon;
      return(
        <div key={t.key} onClick={()=>onChange(t.key)}
          style={{flex:1,textAlign:"center",padding:"14px 10px",cursor:"pointer",
            borderBottom:`2px solid ${active===t.key?TEAL:"transparent"}`,
            color:c,fontSize:16,fontWeight:active===t.key?700:500,
            whiteSpace:"nowrap",minWidth:64,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
          {TabIcon?<TabIcon size={18} strokeWidth={2.25} color={c} aria-hidden/>:t.icon?<span>{t.icon}</span>:null}
          <span>{t.label}</span>
        </div>
      );
    })}
  </div>
);

// ── LOADING OVERLAY ───────────────────────────────────────────────────
export const LoadingOverlay=({msg="請稍等..."})=>(
  <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,
    background:"rgba(0,0,0,0.6)",zIndex:999,
    display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
    <div style={{marginBottom:16,display:"flex",justifyContent:"center"}}>
      <Loader2 size={44} color={WHITE} strokeWidth={2.4} style={{animation:"go-spin 1s linear infinite"}} aria-hidden/>
    </div>
    <p style={{color:WHITE,fontSize:20,fontWeight:700}}>{msg}</p>
    <p style={{color:"rgba(255,255,255,0.75)",fontSize:16}}>請勿關閉此頁面</p>
  </div>
);

// ── PEER PROFILE（配對前預覽：唔顯示電話／電郵）──────────────────────────
const PEER_GENDER_LABEL={male:"男",female:"女",other:"其他"};
export const PeerProfileModal=({open,onClose,role,userId})=>{
  const [loading,setLoading]=useState(false);
  const [prof,setProf]=useState(null);
  const [totalKm,setTotalKm]=useState(null);
  const [kmLoading,setKmLoading]=useState(false);
  useEffect(()=>{
    if(!open||!userId){setProf(null);setLoading(false);return;}
    let cancelled=false;
    setLoading(true);
    const col=role==="driver"?"drivers":"passengers";
    getDoc(doc(db,col,userId)).then(snap=>{
      if(cancelled)return;
      setProf(snap.exists()?snap.data():null);
      setLoading(false);
    }).catch(()=>{
      if(!cancelled){setProf(null);setLoading(false);}
    });
    return()=>{cancelled=true;};
  },[open,role,userId]);
  useEffect(()=>{
    if(!open||!userId){setTotalKm(null);setKmLoading(false);return;}
    let cancelled=false;
    setKmLoading(true);
    const field=role==="driver"?"driverId":"passengerId";
    const q=query(collection(db,"orders"),where(field,"==",userId),where("status","==","completed"),limit(300));
    getDocs(q).then(snap=>{
      if(cancelled)return;
      const km=snap.docs.reduce((acc,d)=>{
        const n=parseFloat(String(d.data()?.distKm??"0"));
        return acc+(Number.isFinite(n)?n:0);
      },0);
      setTotalKm(Math.round(km*10)/10);
      setKmLoading(false);
    }).catch(()=>{
      if(!cancelled){setTotalKm(null);setKmLoading(false);}
    });
    return()=>{cancelled=true;};
  },[open,role,userId]);
  if(!open)return null;
  const title=role==="driver"?"車主檔案":"乘客檔案";
  return(
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(15,23,42,0.55)",zIndex:1100,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"100%",maxWidth:LAYOUT_MAX_W,maxHeight:"88vh",overflowY:"auto",
        background:WHITE,borderRadius:16,boxShadow:"0 20px 50px rgba(0,0,0,0.2)",border:`1px solid ${LIGHT}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px",borderBottom:`1px solid ${LIGHT}`}}>
          <p style={{color:TEXT,fontWeight:800,fontSize:19,margin:0}}>👤 {title}</p>
          <button type="button" onClick={onClose} style={{background:DC,border:`1px solid ${LIGHT}`,borderRadius:10,padding:"8px 14px",fontSize:16,cursor:"pointer",color:TEXT,fontWeight:600}}>關閉</button>
        </div>
        <div style={{padding:16}}>
          {loading&&<p style={{color:SUB,textAlign:"center",padding:24}}>載入緊…</p>}
          {!loading&&!prof&&<p style={{color:SUB,textAlign:"center",padding:24}}>搵唔到檔案</p>}
          {!loading&&prof&&role==="driver"&&(
            <>
              <div style={{textAlign:"center",marginBottom:14}}>
                <div style={{width:88,height:88,borderRadius:"50%",background:DC,overflow:"hidden",margin:"0 auto 10px",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:40,border:`2px solid ${LIGHT}`}}>
                  {prof.selfieURL?<img src={prof.selfieURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>: "👤"}
                </div>
                <p style={{color:TEXT,fontWeight:800,fontSize:20,margin:"0 0 4px"}}>{prof.name||"車主"}</p>
                {prof.gender&&<p style={{color:SUB,fontSize:16,margin:"0 0 6px"}}>⚧ {PEER_GENDER_LABEL[prof.gender]||prof.gender}</p>}
                <StarDisplay rating={prof.ratingCount>0?prof.totalRating/prof.ratingCount:0} count={prof.ratingCount||0}/>
                <p style={{color:SUB,fontSize:14,margin:"8px 0 0"}}>
                  📏 已分享公里：{kmLoading?"計算中…":totalKm!=null?`${totalKm.toFixed(1)} km`:"—"}
                </p>
              </div>
              <Card style={{marginBottom:12}}>
                <p style={{color:SUB,fontSize:16,margin:"0 0 6px"}}>🚗 {prof.plate||"—"} · {prof.vehicleType||"—"}</p>
                {(prof.langs?.length>0)&&<div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:8}}>
                  {prof.langs.map(l=><Tag key={l} label={l} color={SUB}/>)}
                </div>}
                {prof.bio&&<p style={{color:SUB,fontSize:16,margin:"10px 0 0",lineHeight:1.5}}>{prof.bio}</p>}
              </Card>
              {(prof.occupation||prof.expertise?.length>0||prof.hobbies?.length>0)&&(
                <Card style={{background:"#FFFBEB",border:`1px solid ${GOLD}33`,marginBottom:12}}>
                  <p style={{color:GOLD,fontWeight:700,margin:"0 0 8px"}}>☕ Coffee Chat</p>
                  <InterestTags occupation={prof.occupation} expertise={prof.expertise||[]} hobbies={prof.hobbies||[]}/>
                </Card>
              )}
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {prof.acceptChild&&<Tag label="👶 接細路" color={GREEN}/>}
                {prof.acceptPet&&<Tag label="🐾 接寵物" color={WARN}/>}
              </div>
            </>
          )}
          {!loading&&prof&&role==="passenger"&&(
            <>
              <div style={{textAlign:"center",marginBottom:14}}>
                <div style={{width:88,height:88,borderRadius:"50%",background:DC,overflow:"hidden",margin:"0 auto 10px",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:40,border:`2px solid ${LIGHT}`}}>
                  {prof.avatarURL?<img src={prof.avatarURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>: "👤"}
                </div>
                <p style={{color:TEXT,fontWeight:800,fontSize:20,margin:"0 0 4px"}}>{prof.name||"乘客"}</p>
                {prof.gender&&<p style={{color:SUB,fontSize:16,margin:0}}>⚧ {PEER_GENDER_LABEL[prof.gender]||prof.gender}</p>}
                <p style={{color:SUB,fontSize:14,margin:"8px 0 0"}}>
                  📏 已乘坐公里：{kmLoading?"計算中…":totalKm!=null?`${totalKm.toFixed(1)} km`:"—"}
                </p>
              </div>
              {(prof.occupation||prof.expertise?.length>0||prof.hobbies?.length>0)&&(
                <Card style={{background:"#FFFBEB",border:`1px solid ${GOLD}33`}}>
                  <p style={{color:GOLD,fontWeight:700,margin:"0 0 8px"}}>☕ Coffee Chat</p>
                  <InterestTags occupation={prof.occupation} expertise={prof.expertise||[]} hobbies={prof.hobbies||[]}/>
                </Card>
              )}
            </>
          )}
          <p style={{color:SUB,fontSize:14,marginTop:14,lineHeight:1.45}}>聯絡電話同電郵會喺雙方確認配對後先顯示。</p>
        </div>
      </div>
    </div>
  );
};

// ── EMPTY STATE ───────────────────────────────────────────────────────
export const Empty=({icon="📭",msg="暫無資料"})=>(
  <div style={{textAlign:"center",padding:48,color:SUB}}>
    <div style={{fontSize:48,marginBottom:14}}>{icon}</div>
    <p style={{fontSize:18,lineHeight:1.55}}>{msg}</p>
  </div>
);

// ── STATUS BADGE ──────────────────────────────────────────────────────
const STATUS_MAP={
  waiting:{label:"等待中",color:WARN,icon:"🕐"},
  awaiting_passenger:{label:"待乘客確認",color:"#818CF8",icon:"🙋"},
  awaiting_driver:{label:"待車主確認",color:"#818CF8",icon:"🚗"},
  grabbed:{label:"已配對",color:TEAL,icon:"🚗"},
  scheduled_pending:{label:"預約待出發",color:"#818CF8",icon:"📅"},
  completed:{label:"已完成",color:GREEN,icon:"✅"},
  cancelled:{label:"已取消",color:RED,icon:"❌"},
  scheduled:{label:"已預約",color:"#818CF8",icon:"📅"},
  pending:{label:"待審核",color:WARN,icon:"⏳"},
  approved:{label:"已批准",color:GREEN,icon:"✅"},
  rejected:{label:"已拒絕",color:RED,icon:"❌"},
};
export const StatusBadge=({status})=>{
  const s=STATUS_MAP[status]||{label:status,color:SUB,icon:"❓"};
  return <Tag label={`${s.icon} ${s.label}`} color={s.color}/>;
};

// ── DATE/TIME HELPERS ─────────────────────────────────────────────────
export const formatDate=(ts)=>{
  if(!ts)return"";
  const d=ts.toDate?ts.toDate():new Date(ts);
  return d.toLocaleDateString("zh-HK",{month:"short",day:"numeric",weekday:"short"});
};
export const formatTime=(ts)=>{
  if(!ts)return"";
  const d=ts.toDate?ts.toDate():new Date(ts);
  return d.toLocaleTimeString("zh-HK",{hour:"2-digit",minute:"2-digit"});
};
export const formatDateTime=(ts)=>{
  if(!ts)return"";
  return `${formatDate(ts)} ${formatTime(ts)}`;
};
